import api, { unwrapApiResponse } from '../api'

export interface GlobalSearchParams {
  search: string
  page_size?: number
}

export interface SearchEmployeeResult {
  id: string
  first_name: string
  last_name: string
  work_email: string
  profile_picture?: string
  current_position?: { title?: string } | null
}

export interface SearchCandidateResult {
  id: string
  first_name: string
  last_name: string
  email: string
  position_name?: string
}

export interface SearchDocumentResult {
  id: string
  name: string
  template_name?: string
}

export interface SearchContentResult {
  id: string
  title: string
  topic?: string
}

export interface SearchJobProfileResult {
  id: string
  title: string
}

export const searchEmployees = async (search: string) => {
  const res = await api.get('/workforce/', {
    params: { search, page: 1, page_size: 5, expand: 'current_position' },
  })
  return unwrapApiResponse(res, true)
}

export const searchCandidates = async (search: string) => {
  const res = await api.get('/recruitment/candidates/', {
    params: { search, page: 1, page_size: 5, expand: 'position' },
  })
  return unwrapApiResponse(res, true)
}

export const searchDocuments = async (search: string) => {
  const res = await api.get('/documents/templates/', {
    params: { search, page: 1, page_size: 5 },
  })
  return unwrapApiResponse(res, true)
}

export const searchContent = async (search: string) => {
  const res = await api.get('/content/', {
    params: { search, page: 1, page_size: 5 },
  })
  return unwrapApiResponse(res, true)
}

export const searchJobProfiles = async (search: string) => {
  const res = await api.get('/classifications/job-profiles/', {
    params: { search, page: 1, page_size: 5 },
  })
  return unwrapApiResponse(res, true)
}
